import { TypographyStylesProvider } from '@mantine/core';
import './DescriptionRenderer.css';

export const DescriptionRenderer = (props: {
	description: string;
}) => {
	const { description } = props;

	return (
		<TypographyStylesProvider>
			<div
				dangerouslySetInnerHTML={{
					__html: description,
				}}
				className="ProseMirror"
			/>
		</TypographyStylesProvider>
	);
};
